import SearchBar from './SearchBar.container';

export default SearchBar;
